import type { ReactNode } from 'react';
import { type JSX } from 'react/jsx-runtime';

import { ManualMessageViewedEvent } from './message-viewed-component';

/**
 * Messages that use waitForTrigger handle the message view event internally.
 * All other messages use automatic `MessageViewed`.
 *
 */
export const MaybeManualMessageViewedEvent = ({
	isManual,
	children,
}: {
	isManual?: boolean;
	children: ReactNode;
}): JSX.Element => {
	return isManual ? (
		<ManualMessageViewedEvent>{children}</ManualMessageViewedEvent>
	) : (
		<>{children}</>
	);
};
